<template>
<div class="chapter">
<div class="inner_page">
<p class="dedication"><a id="page_v"></a><em>To my daughter, Amy Goldsmith</em></p>
</div>
</div>
</template>
<script>

export default {
  name: 'chapter',
  data() {
    return {}
    },
      components: {
    }
  }
</script>



// WEBPACK FOOTER //
// dedication.vue?7574bbd0